import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useState } from "react";
import ModalHeaderLayout from "../../../layouts/ModalHeaderLayout";
import UserContext from "../../../Context/UserContext";
import axios from "axios";
import { apiUrl } from "../../../config";
import { useTranslation } from "react-i18next";

const ColorModal = ({
  modalOpen,
  setModalOpen,
  selectedRow,
  allData,
  rule,
  setRefreshPage,
  refreshPage
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    description: "",
    front_body_balanced: "",
  });
  // Zorunluluk için hata state ve sağlam boş kontrolü
  const [errors, setErrors] = useState({});
  const isEmptyValue = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string") return v.trim() === "";
    return false;
  };

  useEffect(() => {
    if (modalOpen) {
      setErrors({}); // modal açıldığında uyarıları temizle
    }
  }, [modalOpen, rule, selectedRow]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors((prev) => ({ ...prev, [e.target.name]: undefined })); // alan değişince ilgili hatayı temizle
    }
  };
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_SECRET_KEY;
  useEffect(() => {
    if (selectedRow && rule === "changeOrder") {
      setFormData({
        description: selectedRow.description,
        front_body_balanced: selectedRow.front_body_balanced,

      });
    } else {
      setFormData({
        description: "",
        front_body_balanced: "",

      });
    }
  }, [selectedRow, modalOpen]);

  // Submit öncesi doğrulama
  const validateForm = () => {
    const errs = {};
    if (isEmptyValue(formData.description)) errs.description = `${t("constraints.description")} ${t("constraints.isRequired")}`;
    if (isEmptyValue(formData.front_body_balanced)) errs.front_body_balanced = `${t("constraints.frontBodyBalanced")} ${t("constraints.isRequired")}`;
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errs = validateForm();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return; // eksik varsa API çağrısını durdur

    const requestMethod = rule === "changeOrder" ? axios.put : axios.post;
    let requestData;
    if (rule === "changeOrder") {
      requestData = { ...formData, id: selectedRow.id };
    }
    if (rule === "newOrder") {
      requestData = { ...formData };
    }
    requestMethod(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/addColor`,
      requestData, {
      headers: {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          setFormData({
            description: selectedRow.description,
            front_body_balanced: selectedRow.front_body_balanced,
          })
          setErrors({}); // başarılı submit sonrası uyarıları temizle
          setModalOpen(false)
          setRefreshPage(!refreshPage)
        }
      })
      .catch(err => console.log(err))
  }
  return (
    <Modal
      title=<ModalHeaderLayout title={rule === "changeOrder" ? t("constraints.changeColor") : t("constraints.addColor")} />
      open={modalOpen}
      footer={null}
      onOk={() => setModalOpen(false)}
      onCancel={() => {
        setModalOpen(false);
        setErrors({}); // kapatırken uyarıları temizle
      }}
      centered
      className="min-w-max mb-40"
    >
      <form className='bg-surface pl-10 pr-10 pb-10 rounded-2xl shadow-2xl' onSubmit={handleSubmit}>
        <div className='grid laptop:grid-cols-2 desktop:grid-cols-3 largeDesktop:grid-cols-4 gap-7'>

          <div>
            <label htmlFor="description">{t("constraints.description")}</label>
            <input onChange={(e) => handleChange(e)} type="text" name="description" value={formData.description} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.description && <div className="text-red-600 text-xs mt-1">{errors.description}</div>}
          </div>
          <div>
            <label htmlFor="front_body_balanced">{t("constraints.frontBodyBalanced")} :</label>
            <select onChange={(e) => handleChange(e)} name="front_body_balanced" value={formData.front_body_balanced} className="bg-gray-200 rounded h-8 block w-full mt-1">
              <option value="">{t("constraints.select")}</option>
              <option value="true">{t("constraints.yes")}</option>
              <option value="false">{t("constraints.no")}</option>
            </select>
            {errors.front_body_balanced && <div className="text-red-600 text-xs mt-1">{errors.front_body_balanced}</div>}
          </div>
        </div>
        <div>
          <button type="submit" className="bg-smartopt hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-10 w-full">{t("singularParameters.submit")}</button>
        </div>
      </form>
    </Modal>
  );
};

export default ColorModal;

